/**
 * Created by sunshine on 2016/12/14.
 */
import Vue from 'vue'
import VueResource from 'vue-resource'
import home from './home.vue'
// Resource
Vue.use(VueResource)
new Vue({
  el: '#app',
  template: '<home/>',
  components: {home}
})



// WEBPACK FOOTER //
// ./src/pages/home/index.js